import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBluetoothComponent } from './simple-icons-bluetooth.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBluetoothComponent ],
    exports:      [ SimpleIconsBluetoothComponent ],
    bootstrap:    []
})
export class SimpleIconsBluetoothModule {}
